import React, { useState, useContext, useEffect, useRef } from "react";
import { UserInformationContext, InfoModalContext, C4FStatusContext } from "../main/App";
import { Row, Col, Button, ButtonGroup, Form, Container, InputGroup, Dropdown, DropdownButton } from 'react-bootstrap';
import { HashLink } from 'react-router-hash-link';
import '../css/general.css';
import C4FSimpleTable from "../common/C4FSimpleTable";
import C4FChat from "../common/C4FChat";
import moment from 'moment';

function FairplayCommittee(props) {

  const { userInformation } = useContext(UserInformationContext);
  const { handleBackendRequest } = useContext(C4FStatusContext);
  const { showTeamInfo } = useContext(InfoModalContext);
  const [tab, setTab] = useState('overview');
  const [additionalInvolvedUser, setAdditionalInvolvedUser] = useState('');
  const [fairplayCases, setFairplayCases] = useState([]);
  const [savedFairplayCase, setSavedFairplayCase] = useState(null);
  const [selectedFairplayCase, setSelectedFairplayCase] = useState(null);
  const [caseFilter, setCaseFilter] = useState([]);
  const [selectedInvolvedUser, setSelectedInvolvedUser] = useState(null);
  const [selectedInvolvedView, setSelectedInvolvedView] = useState('users');
  const [logins, setLogins] = useState([]);
  const [suspiciousIPAddresses, setSuspiciousIPAddresses] = useState([]);
  const [selectedHearing, setSelectedHearing] = useState([]);
  const [fairplayCaseVerdict, setFairplayCaseVerdict] = useState(null);
  const mounted = useRef(false);
  const [userRoles, setUserRoles] = useState(null);

  function showSuspiciousIPs() {
    setTab('suspiciousIPAddresses');

    handleBackendRequest('GET', '/statistics/logins', null, null,
      function (result) {
        setLogins(result);
      });
    handleBackendRequest('GET', '/statistics/suspiciousIPAddresses', null, null,
      function (result) {
        setSuspiciousIPAddresses(result);
      });
  }

  function editInvolvedUser(involvedUser) {
    setSelectedInvolvedUser(involvedUser);
  }

  function handleUpdateFairplayCase(fairplayCase) {
    setSelectedFairplayCase(fairplayCase);
  }
  function patchInvolvedUser() {
    handleBackendRequest('PATCH', '/fairplay/' + selectedFairplayCase.caseId + '/user/' + selectedInvolvedUser.userName, selectedInvolvedUser, null,
      function (result) {
        setSelectedInvolvedUser(result.involvedUsers.find(user => user.userName === selectedInvolvedUser.userName));
        handleUpdateFairplayCase(result)
      });
  }

  function executeFairplayDecision() {
    handleBackendRequest('POST', '/fairplay/' + selectedFairplayCase.caseId + '/execute', {}, null, handleUpdateFairplayCase);
  }

  function resetVotes() {
    handleBackendRequest('POST', '/fairplay/' + selectedFairplayCase.caseId + '/resetVotes', {}, null, handleUpdateFairplayCase);
  }

  function getMyVote() {
    if (selectedFairplayCase.votes.some(vote => vote.userId === userInformation.userID))
      return selectedFairplayCase.votes.find(vote => vote.userId === userInformation.userID).vote;
    else return null;
  }

  function vote(vote) {
    handleBackendRequest('POST', '/fairplay/' + selectedFairplayCase.caseId + '/vote', {},
      {
        vote: vote,
        userName: userInformation.userName
      }, handleUpdateFairplayCase);
  }

  function addInvolvedUser() {
    handleBackendRequest('POST', '/fairplay/' + selectedFairplayCase.caseId + '/user', {}, { involvedUser: additionalInvolvedUser },
      function (result) {
        setSelectedInvolvedUser(result.involvedUsers.find(user => user.userName.toLowerCase() === additionalInvolvedUser.toLowerCase()));
        setAdditionalInvolvedUser('');
        handleUpdateFairplayCase(result)
      });
  }

  function removeInvolvedUser(involvedUser) {
    handleBackendRequest('DELETE', '/fairplay/' + selectedFairplayCase.caseId + '/user/' + involvedUser.userName, null, null,
      function (result) {
        setSelectedInvolvedUser(null);
        handleUpdateFairplayCase(result)
      });
  }

  function addCase() {
    handleBackendRequest('POST', '/fairplay/', {}, { createdBy: userInformation.userID },
      function (result) {
        setSavedFairplayCase(result);
        setSelectedInvolvedUser(null)
        setAdditionalInvolvedUser('');
        setTab('detail');
        loadFairplayCases();
        handleUpdateFairplayCase(result)
      });
  }

  function setCaseStatus(status) {
    patchCase({
      ...selectedFairplayCase,
      status: status
    });
  }

  function updateCase() {
    patchCase(selectedFairplayCase);
  }

  function patchCase(caseObject) {
    handleBackendRequest('PATCH', '/fairplay/' + selectedFairplayCase.caseId, caseObject, null,
      function (result) {
        setSavedFairplayCase(result);
        loadFairplayCases();
        handleUpdateFairplayCase(result)
      });
  }

  function loadFairplayCases(status = null) {
    handleBackendRequest('GET', '/fairplay/', null,
      {
        status: status === null ? '' : status
      },
      function (result) {
        setFairplayCases(result);
      });
  }

  function loadSelectedFairplayCase(fairplayCase) {
    handleBackendRequest('GET', '/fairplay/' + fairplayCase.caseId, null, null, 
      function (result) {
        setSavedFairplayCase(result);
        handleUpdateFairplayCase(result);
    });
  }

  function unsavedChanges() {
    return selectedFairplayCase.category !== savedFairplayCase.category ||
      selectedFairplayCase.title !== savedFairplayCase.title ||
      selectedFairplayCase.description !== savedFairplayCase.description ||
      selectedFairplayCase.forumLink !== savedFairplayCase.forumLink;
  }

  function handleSelectCase(fairplayCase) {
    setSelectedFairplayCase(fairplayCase);
    setSelectedHearing(fairplayCase.caseId);
    if (fairplayCase.status === 'Closed' || fairplayCase.status === 'Archived')
      setFairplayCaseVerdict(fairplayCase.involvedTeams);
    else
      setFairplayCaseVerdict(null);
  }

  function handleSetCaseFilter(filter) {
    if (filter === 'All') setCaseFilter([]);
    else if (filter === 'Active') setCaseFilter([{
      columnName: 'status', 
      type: 'text', 
      value: 'New|Op|Vo|Cl', 
      regex: 'New|Op|Vo|Cl', 
      valid: true}])
    else setCaseFilter([]);
  }

  useEffect(() => {
    handleBackendRequest('GET', '/user', null, { context: 'specialRoles' }, setUserRoles);
    handleSetCaseFilter('Active');
    if (!userInformation.roles.includes('FairplayCommittee') && !userInformation.roles.includes('Admin'))
      handleSelectCase(userInformation.fairplayCases[0]);
    else loadFairplayCases();

  }, []);

  useEffect(() => {
    mounted.current = true;
  }, []);

  useEffect(() => {
    return () => {
      mounted.current = false;
    }
  }, []);

  if (!userInformation.roles.includes('FairplayCommittee') && !userInformation.roles.includes('Admin'))
    return <div className="container-fluid m-1">
      <Row className="justify-content-center p-1 c4f-stats">
        <h4>Fairplay Hearing</h4>
      </Row>
      <Row className="c4f-stats p-1">
        <Col className="col-12">
          <h5>Cases</h5>
          <C4FSimpleTable key={'hearingCases'}
            initialSortingColumn={'caseId'}
            initialSortingAscending={false}
            hideFilterButtons={true}
            data={userInformation.fairplayCases.map(fairplayCase => ({
              ...fairplayCase,
              creationDateFormatted: moment(fairplayCase.creationDate).format('YYYY-MM-DD'),
              lastUpdateFormatted: moment(fairplayCase.lastUpdate).format('YYYY-MM-DD')
            }))}
            highlightCriteriaKey={'caseId'}
            highlightCriteriaValue={selectedFairplayCase !== null ? selectedFairplayCase.caseId : null} 
            rowMetadata={[
              { columnName: 'caseId', columnDescription: 'Case', cellClickEvent: handleSelectCase },
              { columnName: 'category', columnDescription: 'Category' },
              { columnName: 'title', columnDescription: 'Title', cellClickEvent: handleSelectCase },
              { columnName: 'status', columnDescription: 'Status' },
              { columnName: 'creationDateFormatted', columnDescription: 'Creation Date' },
              { columnName: 'lastUpdateFormatted', columnDescription: 'Last Update' }
            ]}
          />
        </Col>
      </Row>
      <Row className="c4f-stats p-1">
        <Col className="col-12">
          { (selectedFairplayCase && selectedFairplayCase.forumLink !== "") ?
            <><b>Forum Link:</b> <a href={selectedFairplayCase.forumLink} target="_blank" rel="noreferrer">{selectedFairplayCase.forumLink}</a><br/><br/></>
              :
            <br/>
          }
        </Col>
      </Row>
      {selectedFairplayCase && (selectedFairplayCase.status === 'Closed' || selectedFairplayCase.status === 'Archived') ?
        <Row className="c4f-stats p-1">
          <Col className="col-2" />
          <Col className="col-8">
            <h5>Fairplay Verdict</h5>
            <C4FSimpleTable key={'fairplayCaseVerdict'}
              initialSortingColumn={'userName'}
              initialSortingAscending={false}
              hideFilterButtons={true}
              data={selectedFairplayCase.involvedUsers.map(user => ({ ...user, temporaryBanIndicator: user.temporaryBan === 1 ? 'yes' : 'no' }))}
              rowMetadata={[
                { columnName: 'userName', columnDescription: 'User' },
                { columnName: 'temporaryBanIndicator', columnDescription: 'Banned' },
                { columnName: 'fine', columnDescription: 'Fine' }
              ]}
            />
            <br/>
          </Col>
          <Col className="col-2" />
        </Row>
        : null}
      {selectedHearing !== null ?
      <>
        <Row className="c4f-stats p-1">
          <Col className="m-0 p-1 d-flex justify-content-center">
            <h5>Hearing</h5>
          </Col>
        </Row>
        <Row className="c4f-stats p-1">
          <Col className="m-0 p-1 d-flex justify-content-center">
            <div className="border border-secondary px-3 py-0" style={{ minWidth: 500, maxWidth: 700, backgroundColor: 'rgba(255, 255, 255, 1)' }}>
            <C4FChat key={'fairplayHearing'} type="fairplayHearing"
              mode="readwrite"
              chat={selectedHearing} user={userInformation.userName}
              height={500} />
            </div>
          </Col>
        </Row>
        </>
        : null}
    </div>;
  else
    if (userInformation !== null)
      return <div className="container-fluid m-1">
        <Row className="justify-content-center p-1 c4f-stats">
          <ButtonGroup>
            <Button variant={(tab === 'overview') ? 'primary' : 'outline-primary'} onClick={() => setTab('overview')}>Cases Overview</Button>
            {/* <Button variant={'outline-success'} onClick={() => loadFairplayCases()}>{'Refresh \u21BB'}</Button> */}
            {selectedFairplayCase !== null ?
              <Button variant={(tab === 'detail') ? 'primary' : 'outline-primary'} onClick={() => setTab('detail')}>Case Details</Button>
              :
              <Button variant={'outline-primary'} disabled>Case Details</Button>
            }
            <Button variant={(tab === 'suspiciousIPAddresses') ? 'primary' : 'outline-primary'} onClick={() => showSuspiciousIPs()}>Suspicious IPs</Button>
            <Button variant={(tab === 'rules') ? 'primary' : 'outline-primary'} onClick={() => setTab('rules')}>Rules</Button>
            <Button variant={(tab === 'fpc') ? 'primary' : 'outline-primary'} onClick={() => setTab('fpc')}>FPC</Button>
            <Button variant={(tab === 'links') ? 'primary' : 'outline-primary'} onClick={() => setTab('links')}>Links</Button>
          </ButtonGroup>
        </Row>
        {tab === 'overview' ?
          <>
            <div className="row d-flex c4f-stats p-1">
              <div className="col">
                <h5>Cases</h5>
                <C4FSimpleTable key={'cases'}
                  initialSortingColumn={'caseId'}
                  initialSortingAscending={false}
                  highlightCriteriaKey={'caseId'}
                  highlightCriteriaValue={selectedFairplayCase !== null ? selectedFairplayCase.caseId : null}                  
                  data={fairplayCases.slice().map(record => ({
                    ...record,
                    creationDateFormatted: moment(record.creationDate).format('YYYY-MM-DD'),
                    lastUpdateFormatted: moment(record.lastUpdate).format('YYYY-MM-DD'),
                    creationDateMath: new Date(record.creationDate),
                    daysOpen: Math.floor(Math.abs(new Date() - new Date(record.creationDate)) / 1000 / 3600 / 24,0),
                    maxVerdictClosed: (record.status === 'Closed' || record.status === 'Archived') ? record.maxVerdict : '-', 
                  }))}
                  hideColumnVisibility={true}
                  addRecord={addCase}
                  refreshTable={loadFairplayCases}
                  filters={caseFilter}
                  rowMetadata={[
                    { columnName: 'caseId', columnDescription: 'Case', cellClickEvent: loadSelectedFairplayCase },
                    { columnName: 'category', columnDescription: 'Category' },
                    { columnName: 'title', columnDescription: 'Title', cellClickEvent: loadSelectedFairplayCase },
                    { columnName: 'status', columnDescription: 'Status' },
                    { columnName: 'maxVerdictClosed', columnDescription: 'Max.Verdict' },
                    { columnName: 'creationDateFormatted', columnDescription: 'Creation Date' },
                    { columnName: 'daysOpen', columnDescription: 'Days Open' }
                  ]}
                />
              </div>
            </div>
            <div className="row d-flex c4f-stats p-1">
              <div className="col m-0 p-1"  style={{ minWidth: 100, maxWidth: 400}}>
                {selectedFairplayCase !== null ?
                  <>
                    <h5>Involved Users</h5>
                    <C4FSimpleTable key={'involvedUsers'}
                      initialSortingColumn={'caseId'}
                      initialSortingAscending={false}
                      hideFilterButtons={true}
                      data={selectedFairplayCase.involvedUsers.map(user => ({ ...user, temporaryBanIndicator: user.temporaryBan === 1 ? 'yes' : 'no' }))}
                      rowMetadata={[
                        { columnName: 'userName', columnDescription: 'User', cellClickEvent: showTeamInfo },
                        { columnName: 'temporaryBanIndicator', columnDescription: 'Ban'},
                        { columnName: 'fine', columnDescription: 'Fine'}
                      ]}
                    />
                    <h5>Votes</h5>
                    <C4FSimpleTable key={'votes'}
                      initialSortingColumn={'userName'}
                      initialSortingAscending={true}
                      hideFilterButtons={true}
                      data={selectedFairplayCase.votes}
                      rowMetadata={[
                        { columnName: 'userName', columnDescription: 'User' },
                        { columnName: 'vote', columnDescription: 'Vote' }
                      ]}
                    />
                  </>
                  : null}
              </div>
              <div className="col m-0 p-1">
                <h5>General FPC Chat</h5>
                <div className="border border-secondary px-3 py-0" style={{ minWidth: 500, maxWidth: 700, backgroundColor: 'rgba(255, 255, 255, 1)' }}>
                <C4FChat key={'fairplayInternalGeneral'} type="fairplayInternal"
                  mode="readwrite"
                  chat={0} user={userInformation.userName}
                  refresh={0} height={360} />
                </div>
              </div>
            </div>
          </>
          : null}
        {tab === 'detail' && selectedFairplayCase !== null ?
          <>
            <div className="row d-flex c4f-stats p-1">
            <div className="col m-0 p-1" style={{minWidth: 400}}>
                {selectedFairplayCase.status !== 'Archived' ?
                  <>
                    <h5>Actions</h5>
                    {selectedFairplayCase.status === 'New' && selectedFairplayCase.involvedUsers.length > 0 ?
                      <Button className="mr-1" size="sm" variant={'primary'} onClick={() => setCaseStatus('Open')}>Start Hearing</Button>
                      : null
                    }
                    {selectedFairplayCase.status === 'Open' ?
                      <Button className="mr-1" size="sm" variant={'primary'} onClick={() => setCaseStatus('Voting')}>Start Voting</Button>
                      : null
                    }
                    {selectedFairplayCase.status === 'Voting' ?
                      <Button className="mr-1" size="sm" variant={'warning'} onClick={() => resetVotes()}>Stop Voting & Continue Discussion</Button>
                      : null
                    }
                    {selectedFairplayCase.status === 'Voting' ?
                      <Button className="mr-1" size="sm" variant={'danger'} onClick={() => executeFairplayDecision()}>Execute Decision</Button>
                      : null
                    }
                    {selectedFairplayCase.status === 'New' || selectedFairplayCase.status === 'Open' || selectedFairplayCase.status === 'Voting' ?
                      <Button className="mr-1" size="sm" variant={'danger'} onClick={() => setCaseStatus('Cancelled')}>Cancel Case</Button>
                      : null
                    }
                    {selectedFairplayCase.status === 'Cancelled' ?
                      <Button className="mr-1" size="sm" variant={'warning'} onClick={() => setCaseStatus('New')}>Reopen Case</Button>
                      : null
                    }
                    {selectedFairplayCase.status === 'Closed' ?
                      <Button className="mr-1" size="sm" variant={'secondary'} onClick={() => setCaseStatus('Archived')}>Archive Case</Button>
                      : null
                    }
                  </>
                  : null
                }
                <br/>
                <br/>
                <h5>Case Details (automatic)</h5>
                <div className="input-group input-group-sm mt-0">
                <div class="input-group-prepend w-25">
                  <span class="input-group-text" id="inputGroup-sizing-sm"><b>Case ID</b></span>
                </div>
                  <Form.Control type={'text'} disabled
                    value={selectedFairplayCase.caseId} />
                </div>
                <div className="input-group input-group-sm mt-0 ">
                <div class="input-group-prepend w-25">
                  <span class="input-group-text" id="inputGroup-sizing-sm"><b>Status</b></span>
                </div>
                  <Form.Control type={'text'} disabled
                    value={selectedFairplayCase.status} />
                </div>
                <div className="input-group input-group-sm mt-0 ">
                <div class="input-group-prepend w-25">
                  <span class="input-group-text" id="inputGroup-sizing-sm"><b>Creation Date</b></span>
                </div>
                  <Form.Control type={'text'} disabled
                    value={moment(selectedFairplayCase.creationDate).format('YYYY-MM-DD')} />
                </div>
                <div className="input-group input-group-sm mt-0 ">
                <div class="input-group-prepend w-25">
                  <span class="input-group-text" id="inputGroup-sizing-sm"><b>Last Update</b></span>
                </div>
                  <Form.Control type={'text'} disabled
                    value={moment(selectedFairplayCase.lastUpdate).format('YYYY-MM-DD')} />
                </div>
                <br/>
                <h5>Case Details (FPC input)</h5>
                {selectedFairplayCase.status === 'Open' || selectedFairplayCase.status === 'New' ?
                  <>
                    <div className="input-group input-group-sm mt-0">
                      <div class="input-group-prepend w-25">
                        <span class="input-group-text" id="inputGroup-sizing-sm"><b>Category</b></span>
                      </div>
                      <DropdownButton
                        title={selectedFairplayCase.category}
                        variant={'primary'}
                        size="sm"
                        onSelect={(newValue, e) => setSelectedFairplayCase({ ...selectedFairplayCase, category: newValue })}>
                        {['MultiAccount', 'TeamAttack', 'Bugusing', 'Behaviour', 'Other'].map(category =>
                          <Dropdown.Item key={category} eventKey={category}>{category}</Dropdown.Item>)
                        }
                      </DropdownButton>
                    </div>
                    <div className="input-group input-group-sm mt-0">
                      <div class="input-group-prepend w-25">
                        <span class="input-group-text" id="inputGroup-sizing-sm"><b>Case Title</b></span>
                      </div>
                      <Form.Control type={'text'}
                        onChange={(e) => setSelectedFairplayCase({ ...selectedFairplayCase, title: e.target.value })}
                        placeholder={'title'}
                        value={selectedFairplayCase.title} />
                    </div>
                    <div className="input-group input-group-sm mt-0">
                      <div class="input-group-prepend w-25">
                        <span class="input-group-text" id="inputGroup-sizing-sm"><b>Description</b></span>
                      </div>
                      <Form.Control type={'textarea'}
                        onChange={(e) => setSelectedFairplayCase({ ...selectedFairplayCase, description: e.target.value })}
                        placeholder={'description'}
                        value={selectedFairplayCase.description} />
                    </div>
                    <div className="input-group input-group-sm mt-0">
                      <div class="input-group-prepend w-25">
                        <span class="input-group-text" id="inputGroup-sizing-sm"><b>Forum Link</b></span>
                      </div>
                      <Form.Control type={'text'}
                        onChange={(e) => setSelectedFairplayCase({ ...selectedFairplayCase, forumLink: e.target.value })}
                        placeholder={'Insert Forum Link'}
                        value={selectedFairplayCase.forumLink} />
                    </div>
                  </>
                  :
                  <>
                    <div className="input-group input-group-sm mt-0">
                      <div class="input-group-prepend w-25">
                        <span class="input-group-text" id="inputGroup-sizing-sm"><b>Category</b></span>
                      </div>
                      <Form.Control type={'text'} disabled value={selectedFairplayCase.category} />
                    </div>
                    <div className="input-group input-group-sm mt-0">
                      <div class="input-group-prepend w-25">
                        <span class="input-group-text" id="inputGroup-sizing-sm"><b>Case Title</b></span>
                      </div>
                      <Form.Control type={'text'} disabled value={selectedFairplayCase.title} />
                      </div>
                    <div className="input-group input-group-sm mt-0">
                      <div class="input-group-prepend w-25">
                        <span class="input-group-text" id="inputGroup-sizing-sm"><b>Description</b></span>
                      </div>
                      <Form.Control type={'text'} disabled value={selectedFairplayCase.description} />
                      </div>
                    <div className="input-group input-group-sm mt-0">
                      <div class="input-group-prepend w-25">
                        <span class="input-group-text" id="inputGroup-sizing-sm"><b>Forum Link</b></span>
                      </div>
                      <div class="input-group-prepend w-25">
                        <span class="input-group-text" id="inputGroup-sizing-sm"><a href={selectedFairplayCase.forumLink} target="_blank" rel="noreferrer">{selectedFairplayCase.forumLink}</a></span>
                      </div>
                    </div>
                  </>
                }
                <div className="input-group input-group-sm mt-0">
                      <div class="input-group-prepend w-25">
                        <span class="input-group-text" id="inputGroup-sizing-sm"><b>Action</b></span>
                      </div>
                {unsavedChanges() ?
                  <Button size="sm" variant={'success mb-1'} onClick={() => updateCase()}>Save Changes</Button>
                  :
                  <Button size="sm" variant={'outline-success mb-1'} disabled>Save Changes</Button>
                }
                </div>
              </div>
              <div className="col m-0 p-1">
                <h5>Involved Users, Riders & Palmares Entries</h5>
                <ButtonGroup>
                  <Button size="sm" variant={(selectedInvolvedView === 'users') ? 'primary' : 'outline-primary'} onClick={() => setSelectedInvolvedView('users')}>Users</Button>
                  <Button size="sm" variant={(selectedInvolvedView === 'riders') ? 'primary' : 'outline-primary'} onClick={() => setSelectedInvolvedView('riders')} disabled>Riders</Button>
                  <Button size="sm" variant={(selectedInvolvedView === 'palmares') ? 'primary' : 'outline-primary'} onClick={() => setSelectedInvolvedView('palmares')} disabled>Palmares Entries</Button>
                </ButtonGroup>
                <br/>
                <br/>
                <h5>Involved {selectedInvolvedView}</h5>
                <C4FSimpleTable key={'users'}
                  initialSortingColumn={'userId'}
                  initialSortingAscending={false}
                  hideFilterButtons={true}
                  highlightCriteriaKey={'userId'}
                  highlightCriteriaValue={selectedInvolvedUser !== null ? selectedInvolvedUser.userId : null} 
                  data={selectedFairplayCase.involvedUsers.map(user => ({ ...user, 
                  temporaryBanIndicator: user.temporaryBan === 1 ? 'yes' : 'no',
                  edit: '\u270E',
                  delete: '\u2715'}))}
                  rowMetadata={[
                    { columnName: 'userId', columnDescription: 'ID' },
                    { columnName: 'userName', columnDescription: 'User', cellClickEvent: showTeamInfo },
                    { columnName: 'temporaryBanIndicator', columnDescription: 'Ban' },
                    { columnName: 'banDuration', columnDescription: 'Duration (days)' },
                    { columnName: 'fine', columnDescription: 'Fine' },
                    { columnName: 'edit', columnDescription: '\u270E', columnType: 'button', cellClickEvent: selectedFairplayCase.status === 'Open' || selectedFairplayCase.status === 'New' ? editInvolvedUser : null, className: 'py-0 btn-success'},
                    { columnName: 'delete', columnDescription: '\u2715', columnType: 'button', cellClickEvent: selectedFairplayCase.status === 'Open' || selectedFairplayCase.status === 'New' ? removeInvolvedUser : null, className: 'py-0 btn-danger'}
                  ]}
                />
                {selectedFairplayCase.status === 'Open' || selectedFairplayCase.status === 'New' ?
                  <>
                    <div className="input-group input-group-sm mt-0">
                      <Form.Control type={'text'}
                        onChange={(e) => setAdditionalInvolvedUser(e.target.value)}
                        placeholder={'additional involved user'}
                        value={additionalInvolvedUser} />
                      <Button className="ml-1" variant={'primary'} size="sm" onClick={() => addInvolvedUser()}>Add</Button>
                    </div>
                    {selectedInvolvedUser !== null ?
                      <>
                        <br/>
                        <h5>User Penalty for: {selectedInvolvedUser.userName}</h5>
                        <div className="input-group input-group-sm mt-0">
                          <div class="input-group-prepend w-25">
                            <span class="input-group-text" id="inputGroup-sizing-sm"><b>Ban</b></span>
                          </div>
                          <InputGroup.Checkbox key={'checkbox'}
                            checked={selectedInvolvedUser.temporaryBan === 1 ? true : false}
                            onChange={(e) => setSelectedInvolvedUser({ ...selectedInvolvedUser, temporaryBan: e.target.checked ? 1 : 0 })} />
                        </div>
                        <div className="input-group input-group-sm mt-0">
                          <div class="input-group-prepend w-25">
                            <span class="input-group-text" id="inputGroup-sizing-sm"><b>Duration (days)</b></span>
                          </div>
                          <Form.Control type={'text'}
                            onChange={(e) => setSelectedInvolvedUser({ ...selectedInvolvedUser, banDuration: e.target.value })}
                            placeholder={'ban duration'}
                            value={selectedInvolvedUser.banDuration} />
                        </div>
                        <div className="input-group input-group-sm mt-0">
                          <div class="input-group-prepend w-25">
                            <span class="input-group-text" id="inputGroup-sizing-sm"><b>Fine</b></span>
                          </div>
                          <Form.Control type={'text'}
                            onChange={(e) => setSelectedInvolvedUser({ ...selectedInvolvedUser, fine: e.target.value })}
                            placeholder={'fine'}
                            value={selectedInvolvedUser.fine} />
                        </div>
                        <div className="input-group input-group-sm mt-0">
                          <div class="input-group-prepend w-25">
                            <span class="input-group-text" id="inputGroup-sizing-sm"><b>Action</b></span>
                          </div>
                          <Button variant={'success'} size="sm" onClick={() => patchInvolvedUser()}>{'Save Changes'}</Button>
                          </div>
                      </>
                      : null}
                  </>
                  : null}
                {selectedFairplayCase.status === 'Voting' || selectedFairplayCase.status === 'Closed' || selectedFairplayCase.status === 'Cancelled' ?
                  <>
                    <h5>Votes</h5>
                    {selectedFairplayCase.status === 'Voting' ?
                      <ButtonGroup className="my-1">
                        <Button variant={getMyVote() === 'Open' ? 'secondary' : 'outline-secondary'} size="sm" onClick={() => vote('Open')}>Open</Button>
                        <Button variant={getMyVote() === 'Agree' ? 'success' : 'outline-success'} size="sm" onClick={() => vote('Agree')}>Agree</Button>
                        <Button variant={getMyVote() === 'Abstain' ? 'warning' : 'outline-warning'} size="sm" onClick={() => vote('Abstain')}>Abstain</Button>
                        <Button variant={getMyVote() === 'Disagree' ? 'danger' : 'outline-danger'} size="sm" onClick={() => vote('Disagree')}>Disagree</Button>
                      </ButtonGroup>
                      : null}
                    <C4FSimpleTable key={'votes'}
                      initialSortingColumn={'userName'}
                      initialSortingAscending={true}
                      hideFilterButtons={true}
                      data={selectedFairplayCase.votes}
                      rowMetadata={[
                        { columnName: 'userId', columnDescription: 'UserID' },
                        { columnName: 'userName', columnDescription: 'User' },
                        { columnName: 'vote', columnDescription: 'Vote' }
                      ]}
                    />
                  </>
                  : null}
              </div>
            </div>
            <div className="row d-flex c4f-stats p-1">
              <div className="col m-0 p-1">
                <h5>FPC Internal Chat</h5>
                <div className="border border-secondary px-3 py-0" style={{ minWidth: 400, maxWidth: "80vw", backgroundColor: 'rgba(255, 255, 255, 1)' }}>
                <C4FChat key={'fairplayInternal'} type="fairplayInternal"
                  mode="readwrite"
                  chat={selectedFairplayCase.caseId} user={userInformation.userName}
                  height={360} />
                </div>
              </div>
              <div className="col m-0 p-1">
                <h5>Hearing Chat</h5>
                <div className="border border-secondary px-3 py-0" style={{ minWidth: 400, maxWidth: "80vw", backgroundColor: 'rgba(255, 255, 255, 1)' }}>
                <C4FChat key={'fairplayHearing'} type="fairplayHearing"
                  mode="readwrite"
                  chat={selectedFairplayCase.caseId} user={userInformation.userName}
                  height={360} />
                </div>
              </div>
            </div>
          </>
          : null}
        {tab === 'suspiciousIPAddresses' ?
          <>
            <Row className="c4f-stats p-1">
              <h5>Suspicious IP Addresses</h5>
            </Row>
            <Row className="c4f-stats p-1">
              <Col className="col-5">
                <C4FSimpleTable key={'suspiciousIPAddresses'}
                  initialSortingColumn={'usersCount'}
                  initialSortingAscending={false}
                  hideFilterButtons={true}
                  data={suspiciousIPAddresses}
                  rowMetadata={[
                    { columnName: 'ip', columnDescription: 'IP address' },
                    { columnName: 'userId', columnDescription: 'ID' },
                    { columnName: 'userName', columnDescription: 'Name', cellClickEvent: showTeamInfo },
                    { columnName: 'loginTime', columnDescription: 'Time' }
                  ]}
                />
              </Col>
              <Col className="col-7">
                <C4FSimpleTable key={'logins'}
                  initialSortingColumn={'loginTime'}
                  initialSortingAscending={false}
                  data={logins}
                  rowMetadata={[
                    { columnName: 'userId', columnDescription: 'ID' },
                    { columnName: 'userName', columnDescription: 'User', cellClickEvent: showTeamInfo },
                    { columnName: 'ip', columnDescription: 'IP address' },
                    { columnName: 'loginTime', columnDescription: 'Time' },
                    { columnName: 'version', columnDescription: 'Version' }
                  ]}
                />
              </Col>
            </Row>
          </>
          : null}
        {tab === 'rules' ?
          <>
            <div className="row d-flex justify-content-center">
                <div className="col">
                  <h3>Fairplay Rules</h3>
                  <ol>
                    <li><b><HashLink smooth to='/fairplay/#fairplay_inrace'>In-Race Fairplay</HashLink></b>
                      <ul>
                        <li><HashLink smooth to='/fairplay/#fairplay_teamattacks'>Prohibited Team Attacks</HashLink></li>
                        <li><HashLink smooth to='/fairplay/#fairplay_arrangements'>Unrealistic Arrangements</HashLink></li>
                        <li><HashLink smooth to='/fairplay/#fairplay_sitting'>Sitting</HashLink></li>
                      </ul>
                    </li>
                    <li><b><HashLink smooth to='/fairplay/#fairplay_language'>Offensive Language</HashLink></b>
                    </li>
                    <li><b><HashLink smooth to='/fairplay/#fairplay_cheating'>Technical Cheating</HashLink></b>
                    </li>
                  </ol>
                  <br />
                  <h4 id="fairplay_inrace">1. In-Race Fairplay</h4>
                  <p>To ensure fair tactics and realistic gameplay, there are some prohibited team attacks.</p>
                  <p>
                    <h5 id="fairplay_teamattacks">Prohibited team attacks:</h5>
                    <b>1&#41; Normal Team Attack:</b> Attack (not following) with more than 2 riders of one team at the same km out of the same group. This rule is deactivated for the last 10 km of every race.<br />
                    <b>2&#41; Combined Team Attack:</b> Attack (not following) with more than 5 riders of one team during 20 km out of the same group, if these riders end up in the same group. This rule is deactivated in the second half of every race.<br />
                    <b>3&#41; Chained Attacks:</b> Escape (attacking or following) with more than 2 riders of one team at the same km out of the same group. This rule is deactivated:<br />
                    - if ≥11 riders from ≥4 teams escape, or<br />
                    - if the original group has ≤14 riders, or<br />
                    - if there are ≤20 km left in the race, or<br />
                    - if the road incline is ≥4%.<br />
                  </p>
                  <h5 id="fairplay_arrangements">Unrealistic Arrangements:</h5>
                  <p>Unrealistic arrangements are not allowed. Every manager must do the best for his team. Separation of private and C4F is required.</p>
                  <h5 id="fairplay_sitting">Sitting:</h5>
                  <ul>
                    <li>Sitting is only permitted in stage races (prohibited for one-day races).</li>
                    <li>During stage races, it is mandatory to be online at least 20% of the stages (no sitter logged in during those stages).</li>
                    <li>It is prohibited to share your password with another team. Any case of password sharing will be treated like a multi account case.</li>
                  </ul>
                  <br />
                  <h4 id="fairplay_language">2. Offensive Language</h4>
                  <p>
                    This game may be played by minors. Therefore, players shall use appropriate and respectful language. Furthermore, users commit themselves to adapt their language and behavior to the laws and manners protecting minors.<br />
                  </p>
                  <p>
                    Each user commits himself not to use terms or names with racist, pornographic or sexist connotations or other offensive terms that are against good manners.
                  </p>
                  <p>
                    Direct and obvious insults, offensive language or harmful/offensive behavior will be sanctioned, including, but not limited to:
                  </p>
                  <ul>
                    <li>Bullying or harassment of other players without insulting them directly, e.g. by sending repeated threats, pejorative labels, hate speech, sexual remarks, or posting false statements as facts, aimed at discrediting or humiliating a targeted player;</li>
                    <li>Repeated usage of insulting Emojis or Ascii Symbols;</li>
                    <li>Defamatory false accusations of players in their role as a volunteer (Developer, FPC member, NC member, Calendar Manager, Race Designer or other role), in particular falsely accusing them of manipulations to their own advantage with the effect of harming the game’s reputation.</li>
                  </ul>
                  <p>
                    These rules apply to all means of communication concerning the game, including the race chat, spectator chat, general chat and the <a href="http://www.radsportfreaks.de/RSFForum" target="_blank" rel="noreferrer">Forum</a>.
                  </p>
                  <br />
                  <h4 id="fairplay_cheating">3. Technical Cheating</h4>
                  <p>
                    Technical cheating is forbidden, including, but not limited to:
                  </p>
                  <ul>
                    <li><b>Owning multiple accounts:</b>  It is prohibited to create more than one account per user to play the game. Multi accounts will be deleted.</li>
                    <li><b>Usage of VPNs:</b> To fight multi accounts, the use of browsers or extensions that let the user hide and change their IP constantly without plausible explanation is not allowed.</li>
                    <li><b>Usage of Bugs:</b> Using obvious or officially announced bugs in the game to gain an unfair advantage over other players is prohibited.</li>
                    <li><b>Direct or indirect manipulation of the game:</b> Any cheating by usage of technical means, including, but not limited to, hacking other players accounts or the game’s server is prohibited.</li>
                  </ul>
                </div>
              </div>
          </>
          : null}
        {tab === 'fpc' ?
          <>
            <div className="row d-flex justify-content-center">
                <div className="col">
                  <h3>Fairplay Committee &#40;FPC&#41;</h3>
                  <ol>
                    <li><b><HashLink smooth to='/fairplay/#fpc_summary'>Summary</HashLink></b>
                    </li>
                    <li><b><HashLink smooth to='/fairplay/#fpc_members'>Members</HashLink></b>
                    </li>
                    <li><b><HashLink smooth to='/fairplay/#fpc_mode'>Mode of Operation</HashLink></b>
                    </li>
                    <li><b><HashLink smooth to='/fairplay/#fpc_penalties'>Penalty Guidelines</HashLink></b>
                    </li>
                  </ol>
                  <br />
                  <h4 id="fpc_summary">1. Summary</h4>
                  <p>The FPC is the organization in C4F that is responsible for:</p>
                  <ul>
                    <li>Handling cases that affect the fair play in the game, most importantly violations of the rules;</li>
                    <li>Reading and responding in the fairplay section of the <a href="http://www.radsportfreaks.de/RSFForum" target="_blank" rel="noreferrer">Forum</a> and investigating accusations;</li>
                    <li>Interfering in the race chat if there is a fair play incident.</li>
                  </ul>
                  <h4 id="fpc_members">2. Members</h4>
                  <p>The FPC shall consist of players that have been found suitable for this role. For the moment, the following players are FPC members:</p>
                  {userRoles ?
                  <C4FSimpleTable key={'userRoles'}
                  initialSortingColumn={'role'}
                  initialSortingAscending={true}
                  hideColumnVisibility={true}
                  data={userRoles
                    .filter(a => a.role === "FairplayCommittee")
                    .map(record => ({
                      ...record
                    }))}
                  rowMetadata={[
                    { columnName: 'userName', columnDescription: 'User' },
                    { columnName: 'acronym', columnDescription: 'Acronym' },
                    { columnName: 'forumAccount', columnDescription: 'Forum Account' }
                  ]}
                />
                  : null}
                  <p>The FPC members are neutral, objective and unbiased in every case that they handle. If a member is biased in any way, this member has the duty to withdraw from the case on the grounds of bias and will not be involved in any decision regarding the case.
                  </p>
                  <h4 id="fpc_mode">3. Mode of Operation</h4>
                  <p>FPC Members have several rights and duties to enforce fairplay rules. They may open a fairplay thread, moderate a fairplay thread, propose a penalty and vote for a penalty. The game developers generally follow the FPC discussions and execute its decisions in the database. They also preserve the right to halt, postpone or veto a decision in the exceptional case that it cannot be implemented technically or poses problems for the game’s existence or further development.</p>
                  <ul>
                    <li><b>Opening a fair play case:</b> Either a player or an FPC member opens a thread in the fair play section, which allows the accused player, as well as others, to comment.</li>
                    <li><b>Discussion:</b> Each FPC member can propose a decision/penalty and has the right to discuss the proposal and counter propose.</li>
                    <li><b>Hearing:</b> The FPC opens an ingame hearing for the involved parties in which they can give their opinion/view about the fairplay issue.</li>
                    <li><b>Voting:</b> Each FPC member has the duty to vote for a proposal. A proposal that gets the majority of votes will be the preliminary judgement. The result of the vote will not be made public.</li>
                    <li><b>Decison-Making:</b> As soon as possible, preferably within 7 days,a decision is made by the FPC internally and then communicated in the respective fair play thread. Exceptions are cases, when a fast decision is not possible due to extensive investigation.</li>
                    <li><b>Executing the decision:</b> The game’s developers generally follow the FPC discussions and execute its decisions in the database as soon as possible, preferably within 3 days. Some of the decisions are automated already &#40;bans, fines&#41; but others are not yet fully automated &#40;C4F points, In-Race Time/Points penaties&#41;</li>
                    <li><b>Appealing against a FPC decision:</b> After the decision has been communicated to the player and made public in the fair play thread, players have 3 days to appeal against it in the case-thread in the forum or in the ingame hearing. If nobody appeals, the decision remains in force. If there is an appeal, the FPC does another voting round as soon as possible, preferably within 7 days.</li>
                  </ul>
                  <h4 id="fpc_penalties">4. Penalty Guidelines</h4>
                  <p>A penalty &#40;or no penalty&#41; is decided by the proposals and the voting in the FPC. Nevertheless, there should be a frame in which a decision should be made according to the severity of the fair play breach and the players fair play history. As different players may have different opinions about penalties for certain fair play breaches, these guidelines will not be made publicly available but will serve the FPC for a better and fairer decision making &#40;prevention of arbitrariness and too much time-consuming discussion in the FPC decision making&#41;.</p>
                  <p>The following principles shall guide any decisions:</p>
                  <ul>
                    <li>Financial advantages gained from fair play breaches shall be reversed through a fine that exceeds the advantage gained.</li>
                    <li>Advantages gained unfairly in a race shall be reversed through time penalties or IS/KOM penalties, if that is possible in a timely manner during a stage race. In extreme cases, palmarés entries can be revoked.</li>
                    <li>Offensive language and technical cheating shall lead to fines and, in extreme cases, to bans.</li>
                    <li>If fair play violations are repeated, or if a player honestly &#40;believably&#41; regrets his fair play violation, that shall be considered in the decision making.</li>
                  </ul>
                </div>
              </div>
          </>
          : null}
        {tab === 'links' ?
          <>
            <Row className="c4f-stats p-1">
              <Col className="col-2" />
              <Col className="col-8">
                <h5>Links</h5>
                <ul>
                    <li><a target="_blank" href="https://docs.google.com/spreadsheets/d/1ohzIvVRSXIhc8soObcZq1xcDkQviNljETUAntpz2BBk/">Penalty Guidelines (DE only)</a></li>
                    <li><a target="_blank" href="https://docs.google.com/spreadsheets/d/1lDL2VZcEcNWPr9p6LJUZ-KKSovck_BfLLt3o8OqciT8/">Explanations for suspicious IPs</a></li>
                </ul>
              </Col>
              <Col className="col-2" />

            </Row>
          </>
          : null}

      </div>;
    else return null;
}

export default FairplayCommittee;
